import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { environment } from "../../../../../environments/environment";

import { Lote } from "../models/lote";
import { Pagination } from "../models/pagination";
import { SearchResult } from "../models/search-result";
import { HttpInterceptor } from "../../../../shared/interceptors/http-interceptor.service";
import { Observable } from "rxjs";
import { Oauth2TokenService } from "../../../../../services/oauth2-token.service";
import { HttpHeaders, HttpParams } from "@angular/common/http";

@Injectable()
export class LoteService {
  loteUrl: string;
  loteGridUrl: string;
  organizacaoUrl: string;
  planoSaudeUrl: string;
  medicoPlanoSaudeUrl: string;
  lote: Lote[] = [];
  pagination: Pagination[] = [];

  constructor(
    private http: HttpInterceptor,
    private router: Router,
    private oauth2Token: Oauth2TokenService
  ) {
    this.loteUrl = environment.api.base_url + "/api/v1/lote";
    this.loteGridUrl = environment.api.base_url + "/api/v1/lote/grid";
    this.organizacaoUrl = environment.api.base_url + "/api/v1/organizacao";
    this.planoSaudeUrl = environment.api.base_url + "/api/v1/plano_saude";
    this.medicoPlanoSaudeUrl =
      environment.api.base_url + "/api/v1/medico_plano_saude";
  }

  getHeaders() {
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.oauth2Token.token}`,
    });
  }

  async getSearchResult(params?: HttpParams): Promise<SearchResult> {
    return this.http
      .get(this.loteUrl, { params, headers: this.getHeaders() })
      .toPromise()
      .then((response) => {
        let result = new SearchResult();
        result.lotes = response.data as Lote[];
        result.pagination = response.meta.pagination as Pagination;
        return result;
      })
      .catch(this.handleError);
  }

  async getSearchResultGrid(params?: HttpParams): Promise<SearchResult> {
    return this.http
      .get(this.loteGridUrl, { params, headers: this.getHeaders() })
      .toPromise()
      .then((response) => {
        let result = new SearchResult();
        result.lotes = response.data as Lote[];
        result.pagination = response.meta.pagination as Pagination;
        return result;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }

  async getLote(id: string): Promise<any> {
    let params = new HttpParams();
    params = params.set("id", id);
    params = params.set(
      "include",
      "emprestimos,organizacao,medico_plano_saude,medico_plano_saude.plano_saude"
    );
    return this.getSearchResult(params).then((result) =>
      result.lotes.find((lote) => lote.id === id)
    );
  }

  async getLoteChange(id: string): Promise<any> {
    let params = new HttpParams();
    params = params.set("id", id);
    return this.getSearchResult(params).then((result) =>
      result.lotes.find((lote) => lote.id === id)
    );
  }

  async update(lote: Lote): Promise<void> {
    const url = `${this.loteUrl}/${lote.id}`;
    return this.http
      .put(url, JSON.stringify(lote), { headers: this.getHeaders() })
      .toPromise()
      .then((res) => {
        this.router.navigate(["/pages/lote/lote-detail/", res.data.id]);
      });
  }

  async create(lote: Lote): Promise<Lote> {
    return this.http
      .post(this.loteUrl, JSON.stringify(lote), { headers: this.getHeaders() })
      .toPromise()
      .then((res) => res);
  }

  async createOrUpdate(lote: Lote): Promise<Lote> {
    const url = `${this.loteUrl}/storeOrUpdate`;
    return this.http
      .post(url, JSON.stringify(lote), { headers: this.getHeaders() })
      .toPromise()
      .then((res) => res);
  }

  async delete(id: string): Promise<void> {
    const url = `${this.loteUrl}/${id}`;
    return this.http
      .delete(url, { headers: this.getHeaders() })
      .toPromise()
      .then((_) => {
        this.router.navigate(["/pages/lote/"]);
      });
  }

  async deleteAll(data: any): Promise<void> {
    const url = `${this.loteUrl}`;
    return this.http.delete(url, { headers: this.getHeaders() }).toPromise();
  }

  async patch(lote: any) {
    const url = `${this.loteUrl}/${lote.id}`;
    return this.http
      .patch(url, JSON.stringify(lote), { headers: this.getHeaders() })
      .toPromise()
      .then((res) => res);
  }

  getOrganizacao(params?: HttpParams): Observable<Array<any>> {
    let url = this.organizacaoUrl;

    return this.http
      .get(url, { params, headers: this.getHeaders() })
      .pipe(map((res) => res.data));
  }

  getPlanoSaude(params?: HttpParams): Observable<Array<any>> {
    let url = this.planoSaudeUrl;

    return this.http
      .get(url, { params, headers: this.getHeaders() })
      .pipe(map((res) => res.data));
  }

  getMedicoPlanoSaude(params?: HttpParams): Observable<Array<any>> {
    let url = this.medicoPlanoSaudeUrl;

    return this.http
      .get(url, { params, headers: this.getHeaders() })
      .pipe(map((res) => res.data));
  }
}
